import { MIXIN_PAGE_SENDING_REQUEST } from '@/mixins/page/mixinPageSendingRequest'
import { showAlertError } from '@/utils/store/alert'

const MIXIN_PAGE_PUT_REQUEST = {
  mixins: [MIXIN_PAGE_SENDING_REQUEST],
  data: () => ({
    // чтобы отправить файлы в компоненте нужно переключить флаг
    putDataHasFiles: false
  }),
  methods: {
    async sendPutRequest (data) {
      try {
        this.startSendingRequest()

        // from vuex
        this.putDataHasFiles ? await this.updateItemAndProcessFiles({ id: data.id, data }) : await this.updateItem(data)

        await this.loadOneItem(data.id)
        this.toggleIsEdit()
      } catch (e) {
        showAlertError(e)
      } finally {
        this.finishSendingRequest()
      }
    }
  }
}

export {
  MIXIN_PAGE_PUT_REQUEST
}
